// src/utils/keywordCleaner.js
// Multilingual keyword cleaner (EN/TH/ZH) with domain stopwords and simple canonicalization.

// English stopwords - common words to filter out
const EN_STOP = new Set([
  'a','an','the','and','or','but','if','so','as','at','by','for','from','in','of','on','to','with','without','into','onto','about','over','under','up','down','out','off','than','then','that','this','these','those','it','its',
  'is','am','are','was','were','be','been','being','do','does','did','doing','have','has','had','having',
  'you','your','yours','we','our','ours','they','them','their','theirs','i','me','my','mine','he','him','his','she','her','hers',
  'here','there','when','where','why','how','what','which','who','whom','whose',
  'can','could','may','might','must','shall','should','will','would',
  'just','only','even','also','too','very','really','quite','much','many','some','any','all','each','every','both','few','more','most','other','such',
  'free','sale','best','top','new','now','today','tonight','live','official','online','info','more','get','make','take','see','know','come','go',
  'yes','no','not','dont','doesn','cant','won','aren','isn','wasn','weren','haven','hasn','hadn','shouldn','wouldn','couldn',
  'january','february','march','april','may','june','july','august','september','october','november','december',
  'jan','feb','mar','apr','jun','jul','aug','sep','oct','nov','dec',
  'monday','tuesday','wednesday','thursday','friday','saturday','sunday',
  'mon','tue','wed','thu','fri','sat','sun'
]);

// Thai stopwords - คำที่ไม่มีความหมายสำคัญในภาษาไทย
const TH_STOP = new Set([
  'และ','หรือ','กับ','ของ','ที่','ใน','เป็น','ได้','ก็','ให้','เข้า','ว่า','ซึ่ง','จะ','มี','มา','ไป','เพื่อ','จาก','ถึง','โดย','ต่อ','อีก','แล้ว','ยัง','มาก','น้อย','ไม่','ใช่','คือ','ครับ','ค่ะ','นะ','จ้า','เลย',
  'นี้','นั้น','นั่น','เหล่า','เหล่านั้น','เหล่านี้','พวก','หลาย','บาง','ทั้ง','ทุก','แต่','ถ้า','เมื่อ','เพราะ','แม้','ขณะ',
  'ผม','ฉัน','เรา','คุณ','พวกเรา','เขา','เธอ','พวกเขา','ท่าน','ตัว','อัน','ตัวเอง',
  'ทำ','ทำให้','ทำได้','เอา','ดู','รู้','คิด','พูด','บอก','ถาม','ตอบ',
  'ดี','ดีมาก','ดีที่สุด','ใหม่','เก่า','สูง','ต่ำ','ใหญ่','เล็ก','กว้าง','แคบ',
  'วัน','คืน','เช้า','บ่าย','เย็น','พรุ่งนี้','เมื่อวาน','วันนี้',
  'จันทร์','อังคาร','พุธ','พฤหัส','ศุกร์','เสาร์','อาทิตย์',
  'มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม',
  'ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'
]);

// Chinese stopwords - 中文停用词
const ZH_STOP = new Set([
  '的','了','和','是','在','有','也','就','不','很','到','及','与','或','而','被','把','对','从','上','下','这','那','个','们','著','還',
  '我','你','他','她','它','我们','你们','他们','她们','它们','自己',
  '什么','哪','哪里','谁','怎么','为什么','多少','几',
  '能','会','可','要','想','应该','必须','得','过','着','了','吗','呢','吧','啊',
  '好','很好','最好','新','旧','大','小','高','低','多','少','长','短',
  '天','日','月','年','今天','明天','昨天','早上','中午','下午','晚上',
  '星期一','星期二','星期三','星期四','星期五','星期六','星期日',
  '一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'
]);

// Domain stopwords for your travel/event app — tune as you review top tokens weekly
const DOMAIN_STOP = new Set([
  // Generic event/travel terms
  'event','events','concert','show','shows','festival','festivals','party','parties','activities','activity',
  'tour','tours','guide','guides','group','groups','chat','chats','app','apps','page','pages',

  // Location/place generic terms
  'thailand','bangkok','bkk','map','maps','location','locations','place','places','nearby','near','area','areas',
  'city','cities','town','towns','village','villages','district','districts','province','provinces',

  // Commerce/booking terms
  'ticket','tickets','price','prices','promotion','promotions','promo','promos','discount','discounts',
  'book','booking','bookings','reserve','reservation','reservations','buy','purchase','free','sale','deal','deals',

  // Common UI/web terms
  'click','view','views','read','more','info','information','details','detail','about','contact','home','search',
  'website','site','web','online','digital','mobile','download','share','like','follow','subscribe',

  // Time-related generic terms
  'time','times','date','dates','schedule','schedules','calendar','day','days','week','weeks','month','months',
  'year','years','season','seasons','hour','hours','minute','minutes',

  // Quality/rating generic terms
  'rating','ratings','review','reviews','star','stars','recommend','recommended','popular','trending','hot','best','top',

  // Added comprehensive travel/event domain terms
  'travel','traveler','travelers','tourist','tourists','visitor','visitors','guest','guests',
  'hotel','hotels','resort','resorts','accommodation','accommodations','stay','stays',
  'restaurant','restaurants','food','foods','drink','drinks','dining','cafe','cafes','bar','bars',
  'entertainment','fun','enjoy','experience','experiences','adventure','adventures',
  'culture','cultural','art','arts','museum','museums','gallery','galleries','exhibition','exhibitions',
  'shopping','shop','shops','mall','malls','market','markets','store','stores',
  'transport','transportation','taxi','taxis','bus','buses','train','trains','station','stations',
  'photo','photos','picture','pictures','image','images','video','videos'
]);

// Canonical/alias normalization - map common variations to standard forms
const CANON_MAP = new Map([
  // Bangkok variations
  ['bkk','bangkok'],
  ['กรุงเทพ','bangkok'],
  ['กทม','bangkok'],
  ['กรุงเทพมหานคร','bangkok'],

  // Common abbreviations
  ['intl','international'],
  ['natl','national'],
  ['ave','avenue'],
  ['st','street'],
  ['rd','road'],
  ['mt','mountain'],

  // Music/entertainment
  ['fest','festival'],
  ['gig','concert'],
  ['dj','disc jockey'],

  // Thai city abbreviations
  ['cmx','chiang mai'],
  ['เชียงใหม่','chiang mai'],
  ['ภูเก็ต','phuket'],
  ['พัทยา','pattaya'],
  ['หัวหิน','hua hin'],

  // Common variations
  ['show case','showcase'],
  ['live music','music'],
  ['night market','market']
]);

// Regex patterns for filtering
const URL_RE = /\bhttps?:\/\/[^\s]+/gi;
const EMAIL_RE = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;
const PUNCT_RE = /[.,/#!$%^&*;:{}=\-_`~()''"""·•|\\[\]]+/g;
const EMOJI_RE = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
const HASHTAG_RE = /#([0-9A-Za-zก-๙一-龥]+)/g;
const DIGITWORD_RE = /^(?:\d+|\d+[a-z]+|[a-z]*\d+[a-z]*)$/i;

/**
 * Normalize input text - lowercase, strip URLs/emails/punctuation/emoji, collapse whitespace
 */
function normalizeBase(text) {
  return text
    .replace(URL_RE, ' ')
    .replace(EMAIL_RE, ' ')
    .replace(EMOJI_RE, ' ')
    .replace(PUNCT_RE, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

/**
 * Choose appropriate stopword set based on language
 */
function chooseStopset(lang) {
  if (!lang) return EN_STOP;
  const l = lang.toLowerCase();
  if (l.startsWith('th')) return TH_STOP;
  if (l.startsWith('zh') || l.startsWith('cn')) return ZH_STOP;
  return EN_STOP;
}

/**
 * Tokenize text using Intl.Segmenter for Thai/Chinese, fallback to regex
 */
function tokenize(text, lang = 'en') {
  if (typeof Intl !== 'undefined' && Intl.Segmenter) {
    try {
      const seg = new Intl.Segmenter(lang, { granularity: 'word' });
      return Array.from(seg.segment(text))
        .filter(s => s.isWordLike)
        .map(s => s.segment)
        .filter(Boolean);
    } catch (e) {
      // Fall through to regex fallback
    }
  }
  // Fallback: split by non-alphanumeric (preserving Thai, Chinese, English)
  return text.split(/[^0-9A-Za-z\u0E00-\u0E7F\u4E00-\u9FFF]+/).filter(Boolean);
}

/**
 * Canonicalize term - apply alias mapping and simple singularization
 */
function canon(term) {
  // Check alias map first
  const mapped = CANON_MAP.get(term) || term;

  // Naive English singularization for common patterns
  if (mapped.length > 3) {
    if (mapped.endsWith('ies')) return mapped.slice(0, -3) + 'y';
    if (mapped.endsWith('sses')) return mapped.slice(0, -2);
    if (mapped.endsWith('ses')) return mapped.slice(0, -1);
    if (mapped.endsWith('s') && !mapped.endsWith('ss') && !mapped.endsWith('us')) {
      return mapped.slice(0, -1);
    }
  }

  return mapped;
}

/**
 * Extract meaningful keywords from free text.
 *
 * @param {string} text - Raw input text to process
 * @param {Object} opts - Options object
 * @param {string} opts.lang - Language code (e.g., 'en', 'th', 'zh')
 * @param {string[]|Set<string>} opts.extraStop - Additional stopwords to filter
 * @param {number} opts.minLen - Minimum token length (default: 3)
 * @param {boolean} opts.keepNumbers - Keep numeric tokens (default: false)
 * @returns {string[]} Array of cleaned keywords
 */
export function extractKeywords(text, opts = {}) {
  if (!text || typeof text !== 'string') return [];

  const langStop = chooseStopset(opts.lang);
  const extraStop = new Set([...(opts.extraStop || [])]);

  const base = normalizeBase(text);
  const tokens = tokenize(base, opts.lang);

  // Rescue hashtag words from original text (already lowercased in base)
  const hashtagWords = [];
  for (const m of base.matchAll(HASHTAG_RE)) {
    if (m[1]) hashtagWords.push(m[1]);
  }

  const all = [...tokens, ...hashtagWords];

  const minLen = Number.isInteger(opts.minLen) ? opts.minLen : 3;
  const keepNumbers = !!opts.keepNumbers;

  const out = [];
  for (let t of all) {
    if (!t) continue;
    t = t.trim();
    if (t.length < minLen) continue;
    if (!keepNumbers && DIGITWORD_RE.test(t)) continue;

    t = canon(t);

    // Filter against all stopword lists
    if (langStop.has(t)) continue;
    if (DOMAIN_STOP.has(t)) continue;
    if (extraStop.has(t)) continue;

    out.push(t);
  }

  // Remove duplicates while preserving order
  return Array.from(new Set(out));
}

/**
 * Build simple adjacent bigrams from tokens.
 * Returns both unigrams and bigrams combined.
 *
 * @param {string[]} tokens - Array of cleaned tokens
 * @returns {string[]} Array of tokens and bigrams
 */
export function buildBigrams(tokens) {
  if (!Array.isArray(tokens) || tokens.length === 0) return [];

  const res = [];
  for (let i = 0; i < tokens.length; i++) {
    const a = tokens[i];
    if (!a) continue;

    // Add unigram
    res.push(a);

    // Add bigram if next token exists
    const b = tokens[i + 1];
    if (b) {
      res.push(`${a} ${b}`);
    }
  }

  // Remove duplicates while preserving order
  return Array.from(new Set(res));
}
